import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useMutation } from 'react-query';
import { useParams } from 'react-router-dom';

import { resetPassword } from '../../../services/api-auth';
import { Snackbar, AppIcon } from '../../../shared/components';

const ResetPassword = () => {
  const { token } = useParams();
  const [isSuccessForm, setIsSuccessForm] = useState(false);
  const [isShowMessage, setIsShowMessage] = useState(false);

  const { handleSubmit, register } = useForm();

  const mutation = useMutation(resetPassword, {
    onSuccess: async () => setIsSuccessForm(true),
    onError: async () => setIsShowMessage(true)
  })

  const onSubmit = (form) => {
    const { newPassword, confirmPassword } = form

    if (newPassword !== confirmPassword) {
      return setIsShowMessage(true)
    }

    mutation.mutate({
      token,
      password: newPassword
    })
  }

  const renderForm = () => <>
    <form
      className="container-form max-w-[380px]"
      onSubmit={handleSubmit(onSubmit)}
    >

      <AppIcon name="logo" className="mb-12 w-40 mx-auto" />

      <h1 className="text-3xl uppercase font-bold font-helvetica-lt mb-12">Create new password</h1>

      <input
        {...register("newPassword", { required: true })}
        type="password"
        autoComplete="off"
        className="input-default font-roboto mb-4"
        placeholder="New password"
      />

      <input
        {...register("confirmPassword", { required: true })}
        type="password"
        autoComplete="off"
        className="input-default font-roboto mb-4"
        placeholder="Confirm password"
      />
      <p className="text-xs">Both passwords must match</p>

      <input
        className="mt-12 btn-default text-white bg-secondary"
        type="submit" value="Reset Password"
      />
    </form>
    { isShowMessage &&
      <Snackbar
        message="Your passwords do not match, please try again"
        type="error"
        onClose={() => setIsShowMessage(false)}
      />
    }
  </>

  const renderSuccess = () => <div className="container-form max-w-[400px]	items-center">
    <AppIcon name="check-circle" className="w-40 mb-8 text-green-300" />
    <h2 className="text-3xl uppercase font-bold font-helvetica-lt text-center">
      Password reset successful!
    </h2>
    <div className="w-full sm:w-4/5 mx-auto mt-14">
      <a
        href="/app"
        className="btn-default text-white bg-secondary"
      >Log in</a>
    </div>
  </div>

  return <main className="flex justify-center fixed w-full h-full">
    { isSuccessForm ? renderSuccess() : renderForm() }
  </main>
}

export default ResetPassword;